import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";

import routes from "./config";
import Header from "../components/Header";
import Footer from "../components/Footer";
import IntroBlock from "../components/IntroBlock";
import PreFooter from "../components/PreFooter";
import { Styles } from "../styles/styles";

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />

      <Header />

      <IntroBlock />

      <Switch>
        {routes.map((routeItem) => {
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          );
        })}
      </Switch>

      <PreFooter />

      <Footer />
    </Suspense>
  );
};

export default Router;
